import { Injectable } from '@angular/core';
import {map} from 'rxjs/operators';
import {GeneralService} from './general.service';
import {firstValueFrom, Observable, of} from "rxjs";
@Injectable()
export class AWSPollyVoiceData {
    private cachedVoices: any[] | null = null;
    private cachedLanguages: any[] | null = null;



    languages = [
        {languageName: 'Arabic', languageCode: 'arb'},
        {languageName: 'Chinese, Mandarin', languageCode: 'cmn-CN'},
        {languageName: 'Danish', languageCode: 'da-DK'},
        {languageName: 'Dutch', languageCode: 'nl-NL'},
        {languageName: 'English (Australian)', languageCode: 'en-AU'},
        {languageName: 'English (British)', languageCode: 'en-GB'},
        {languageName: 'English (Indian)', languageCode: 'en-IN'},
        {languageName: 'English (US)', languageCode: 'en-US'},
        {languageName: 'English (Welsh)', languageCode: 'en-GB-WLS'},
        {languageName: 'French (Canadian)', languageCode: 'fr-CA'},
        {languageName: 'French', languageCode: 'fr-FR'},
        {languageName: 'German', languageCode: 'de-DE'},
        {languageName: 'Hindi', languageCode: 'hi-IN'},
        {languageName: 'Icelandic', languageCode: 'is-IS'},
        {languageName: 'Italian', languageCode: 'it-IT'},
        {languageName: 'Japanese', languageCode: 'ja-JP'},
        {languageName: 'Korean', languageCode: 'ko-KR'},
        {languageName: 'Norwegian', languageCode: 'nb-NO'},
        {languageName: 'Polish', languageCode: 'pl-PL'},
        {languageName: 'Portuguese (Brazilian)', languageCode: 'pt-BR'},
        {languageName: 'Portuguese (European)', languageCode: 'pt-PT'},
        {languageName: 'Romanian', languageCode: 'ro-RO'},
        {languageName: 'Russian', languageCode: 'ru-RU'},
        {languageName: 'Spanish (European)', languageCode: 'es-ES'},
        {languageName: 'Spanish (Mexican)', languageCode: 'es-MX'},
        {languageName: 'Swedish', languageCode: 'sv-SE'},
        {languageName: 'Turkish', languageCode: 'tr-TR'},
        {languageName: 'US Spanish', languageCode: 'es-US'},
        {languageName: 'Welsh', languageCode: 'cy-GB'}
    ];
    voices = [
        {
            languageName: "Arabic",
            languageCode: "arb",
            aac_id: "Zeina",
            id: "Zeina",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Danish",
            languageCode: "da-DK",
            aac_id: "Mads",
            id: "Mads",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Danish",
            languageCode: "da-DK",
            aac_id: "Naja",
            id: "Naja",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Dutch",
            languageCode: "nl-NL",
            aac_id: "Lotte",
            id: "Lotte",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Dutch",
            languageCode: "nl-NL",
            aac_id: "Ruben",
            id: "Ruben",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "English (Australian)",
            languageCode: "en-AU",
            aac_id: "Nicole",
            id: "Nicole",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "English (Australian)",
            languageCode: "en-AU",
            aac_id: "Russell",
            id: "Russell",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "English (Indian)",
            languageCode: "en-IN",
            aac_id: "Aditi",
            id: "Aditi",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "English (Indian)",
            languageCode: "en-IN",
            aac_id: "Raveena",
            id: "Raveena",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "English (Welsh)",
            languageCode: "en-GB-WLS",
            aac_id: "Geraint",
            id: "Geraint",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "French",
            languageCode: "fr-FR",
            aac_id: "Celine",
            id: "Celine",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "French",
            languageCode: "fr-FR",
            aac_id: "Mathieu",
            id: "Mathieu",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "French (Canadian)",
            languageCode: "fr-CA",
            aac_id: "Chantal",
            id: "Chantal",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "German",
            languageCode: "de-DE",
            aac_id: "Hans",
            id: "Hans",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "German",
            languageCode: "de-DE",
            aac_id: "Marlene",
            id: "Marlene",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Hindi",
            languageCode: "hi-IN",
            aac_id: "Aditi*",
            id: "Aditi*",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Icelandic",
            languageCode: "is-IS",
            aac_id: "Dóra/Dora",
            id: "Dóra/Dora",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Icelandic",
            languageCode: "is-IS",
            aac_id: "Karl",
            id: "Karl",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Italian",
            languageCode: "it-IT",
            aac_id: "Carla",
            id: "Carla",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Italian",
            languageCode: "it-IT",
            aac_id: "Giorgio",
            id: "Giorgio",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Japanese",
            languageCode: "ja-JP",
            aac_id: "Mizuki",
            id: "Mizuki",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Norwegian",
            languageCode: "nb-NO",
            aac_id: "Liv",
            id: "Liv",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Polish",
            languageCode: "pl-PL",
            aac_id: "Ewa",
            id: "Ewa",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Polish",
            languageCode: "pl-PL",
            aac_id: "Jacek",
            id: "Jacek",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Polish",
            languageCode: "pl-PL",
            aac_id: "Jan",
            id: "Jan",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Polish",
            languageCode: "pl-PL",
            aac_id: "Maja",
            id: "Maja",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Portuguese (Brazilian)",
            languageCode: "pt-BR",
            aac_id: "Ricardo",
            id: "Ricardo",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Portuguese (European)",
            languageCode: "pt-PT",
            aac_id: "Cristiano",
            id: "Cristiano",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Romanian",
            languageCode: "ro-RO",
            aac_id: "Carmen",
            id: "Carmen",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Russian",
            languageCode: "ru-RU",
            aac_id: "Maxim",
            id: "Maxim",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Russian",
            languageCode: "ru-RU",
            aac_id: "Tatyana",
            id: "Tatyana",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Spanish (Spain)",
            languageCode: "es-ES",
            aac_id: "Conchita",
            id: "Conchita",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Spanish (Spain)",
            languageCode: "es-ES",
            aac_id: "Enrique",
            id: "Enrique",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Spanish (US)",
            languageCode: "es-US",
            aac_id: "Miguel",
            id: "Miguel",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Spanish (US)",
            languageCode: "es-US",
            aac_id: "Penelope",
            id: "Penelope",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Swedish",
            languageCode: "sv-SE",
            aac_id: "Astrid",
            id: "Astrid",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Turkish",
            languageCode: "tr-TR",
            aac_id: "Filiz",
            id: "Filiz",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "Welsh",
            languageCode: "cy-GB",
            aac_id: "Gwyneth",
            id: "Gwyneth",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: false,
            isStandard: true
        },
        {
            languageName: "English (US)",
            languageCode: "en-US",
            aac_id: "Patrick",
            id: "Patrick",
            gender: "Male",
            generative: false,
            longFormVoice: true,
            isNeural: false,
            isStandard: false
        },
        {
            languageName: "Spanish (Spain)",
            languageCode: "es-ES",
            aac_id: "Alba",
            id: "Alba",
            gender: "Female",
            generative: false,
            longFormVoice: true,
            isNeural: false,
            isStandard: false
        },
        {
            languageName: "Spanish (Spain)",
            languageCode: "es-ES",
            aac_id: "Raúl",
            id: "Raúl",
            gender: "Male",
            generative: false,
            longFormVoice: true,
            isNeural: false,
            isStandard: false
        },
        {
            languageName: "Arabic (Gulf)",
            languageCode: "ar-AE",
            aac_id: "Hala",
            id: "Hala",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "Arabic (Gulf)",
            languageCode: "ar-AE",
            aac_id: "Zayd",
            id: "Zayd",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "Catalan",
            languageCode: "ca-ES",
            aac_id: "Arlet",
            id: "Arlet",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "Chinese (Cantonese)",
            languageCode: "yue-CN",
            aac_id: "Hiujin",
            id: "Hiujin",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "Chinese (Mandarin)",
            languageCode: "cmn-CN",
            aac_id: "Zhiyu",
            id: "Zhiyu",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "Czech",
            languageCode: "cs-CZ",
            aac_id: "Jitka",
            id: "Jitka",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "Danish",
            languageCode: "da-DK",
            aac_id: "Sofie",
            id: "Sofie",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "Dutch",
            languageCode: "nl-NL",
            aac_id: "Laura",
            id: "Laura",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "Dutch (Belgian)",
            languageCode: "nl-BE",
            aac_id: "Lisa",
            id: "Lisa",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "English (Australian)",
            languageCode: "en-AU",
            aac_id: "Olivia",
            id: "Olivia",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "English (British)",
            languageCode: "en-GB",
            aac_id: "Amy",
            id: "Amy",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "English (British)",
            languageCode: "en-GB",
            aac_id: "Arthur",
            id: "Arthur",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "English (British)",
            languageCode: "en-GB",
            aac_id: "Brian",
            id: "Brian",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "English (British)",
            languageCode: "en-GB",
            aac_id: "Emma",
            id: "Emma",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "English (Indian)",
            languageCode: "en-IN",
            aac_id: "Kajal",
            id: "Kajal*",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "English (Ireland)",
            languageCode: "en-IE",
            aac_id: "Niamh",
            id: "Niamh",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "English (New Zealand)",
            languageCode: "en-NZ",
            aac_id: "Aria",
            id: "Aria",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "English (Singaporean)",
            languageCode: "en-SG",
            aac_id: "Jasmine",
            id: "Jasmine",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "English (South African)",
            languageCode: "en-ZA",
            aac_id: "Ayanda",
            id: "Ayanda",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "English (US)",
            languageCode: "en-US",
            aac_id: "Ivy",
            id: "Ivy",
            gender: "Female (child)",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "English (US)",
            languageCode: "en-US",
            aac_id: "Joanna",
            id: "Joanna",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: true,
            useConversational: true
        },
        {
            languageName: "English (US)",
            languageCode: "en-US",
            aac_id: "Joey",
            id: "Joey",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "English (US)",
            languageCode: "en-US",
            aac_id: "Justin",
            id: "Justin",
            gender: "Male (child)",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "English (US)",
            languageCode: "en-US",
            aac_id: "Kendra",
            id: "Kendra",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "English (US)",
            languageCode: "en-US",
            aac_id: "Kevin",
            id: "Kevin",
            gender: "Male (child)",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "English (US)",
            languageCode: "en-US",
            aac_id: "Kimberly",
            id: "Kimberly",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "English (US)",
            languageCode: "en-US",
            aac_id: "Matthew",
            id: "Matthew",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false,
            useConversational: true
        },
        {
            languageName: "English (US)",
            languageCode: "en-US",
            aac_id: "Salli",
            id: "Salli",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "English (US)",
            languageCode: "en-US",
            aac_id: "Stephen",
            id: "Stephen",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "Finnish",
            languageCode: "fi-FI",
            aac_id: "Suvi",
            id: "Suvi",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "French",
            languageCode: "fr-FR",
            aac_id: "Léa",
            id: "Léa",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "French",
            languageCode: "fr-FR",
            aac_id: "Rémi",
            id: "Rémi",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "French (Belgian)",
            languageCode: "fr-BE",
            aac_id: "Isabelle",
            id: "Isabelle",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "French (Canadian)",
            languageCode: "fr-CA",
            aac_id: "Gabrielle",
            id: "Gabrielle",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "French (Canadian)",
            languageCode: "fr-CA",
            aac_id: "Liam",
            id: "Liam",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "German",
            languageCode: "de-DE",
            aac_id: "Daniel",
            id: "Daniel",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "German",
            languageCode: "de-DE",
            aac_id: "Vicki",
            id: "Vicki",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "German (Austrian)",
            languageCode: "de-AT",
            aac_id: "Hannah",
            id: "Hannah",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "German (Swiss)",
            languageCode: "de-CH",
            aac_id: "Sabrina",
            id: "Sabrina",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "Hindi",
            languageCode: "hi-IN",
            aac_id: "Kajal*",
            id: "Kajal*",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "Italian",
            languageCode: "it-IT",
            aac_id: "Adriano",
            id: "Adriano",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "Italian",
            languageCode: "it-IT",
            aac_id: "Bianca",
            id: "Bianca",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "Japanese",
            languageCode: "ja-JP",
            aac_id: "Kazuha",
            id: "Kazuha",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "Japanese",
            languageCode: "ja-JP",
            aac_id: "Takumi",
            id: "Takumi",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "Japanese",
            languageCode: "ja-JP",
            aac_id: "Tomoko",
            id: "Tomoko",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "Korean",
            languageCode: "ko-KR",
            aac_id: "Jihye",
            id: "Jihye",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "Korean",
            languageCode: "ko-KR",
            aac_id: "Seoyeon",
            id: "Seoyeon",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "Norwegian",
            languageCode: "nb-NO",
            aac_id: "Ida",
            id: "Ida",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "Polish",
            languageCode: "pl-PL",
            aac_id: "Ola",
            id: "Ola",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "Portuguese (Brazilian)",
            languageCode: "pt-BR",
            aac_id: "Camila",
            id: "Camila",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "Portuguese (Brazilian)",
            languageCode: "pt-BR",
            aac_id: "Thiago",
            id: "Thiago",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "Portuguese (Brazilian)",
            languageCode: "pt-BR",
            aac_id: "Vitoria",
            id: "Vitoria",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "Portuguese (European)",
            languageCode: "pt-PT",
            aac_id: "Inês/Ines",
            id: "Inês/Ines",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "Spanish (Mexican)",
            languageCode: "es-MX",
            aac_id: "Andrés",
            id: "Andrés",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "Spanish (Mexican)",
            languageCode: "es-MX",
            aac_id: "Mia",
            id: "Mia",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "Spanish (Spain)",
            languageCode: "es-ES",
            aac_id: "Lucia",
            id: "Lucia",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "Spanish (Spain)",
            languageCode: "es-ES",
            aac_id: "Sergio",
            id: "Sergio",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "Spanish (US)",
            languageCode: "es-US",
            aac_id: "Lupe",
            id: "Lupe",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "Spanish (US)",
            languageCode: "es-US",
            aac_id: "Pedro",
            id: "Pedro",
            gender: "Male",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "Swedish",
            languageCode: "sv-SE",
            aac_id: "Elin",
            id: "Elin",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "Turkish",
            languageCode: "tr-TR",
            aac_id: "Burcu",
            id: "Burcu",
            gender: "Female",
            generative: false,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "English (Australian)",
            languageCode: "en-AU",
            aac_id: "Olivia-(AI)",
            id: "Olivia",
            gender: "Female",
            generative: true,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "English (British)",
            languageCode: "en-GB",
            aac_id: "Amy**-(AI)",
            id: "Amy**",
            gender: "Female",
            generative: true,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "English (Indian)",
            languageCode: "en-IN",
            aac_id: "Kajal*-(AI)",
            id: "Kajal*",
            gender: "Female",
            generative: true,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "English (South African)",
            languageCode: "en-ZA",
            aac_id: "Ayanda-(AI)",
            id: "Ayanda",
            gender: "Female",
            generative: true,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "English (US)",
            languageCode: "en-US",
            aac_id: "Joanna-(AI)",
            id: "Joanna",
            gender: "Female",
            generative: true,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "English (US)",
            languageCode: "en-US",
            aac_id: "Matthew-(AI)",
            id: "Matthew",
            gender: "Male",
            generative: true,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "English (US)",
            languageCode: "en-US",
            aac_id: "Stephen-(AI)",
            id: "Stephen",
            gender: "Male",
            generative: true,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "French",
            languageCode: "fr-FR",
            aac_id: "Léa-(AI)",
            id: "Léa",
            gender: "Female",
            generative: true,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "French",
            languageCode: "fr-FR",
            aac_id: "Rémi-(AI)",
            id: "Rémi",
            gender: "Male",
            generative: true,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "German",
            languageCode: "de-DE",
            aac_id: "Daniel-(AI)",
            id: "Daniel",
            gender: "Male",
            generative: true,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "German",
            languageCode: "de-DE",
            aac_id: "Vicki-(AI)",
            id: "Vicki",
            gender: "Female",
            generative: true,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "Italian",
            languageCode: "it-IT",
            aac_id: "Bianca-(AI)",
            id: "Bianca",
            gender: "Female",
            generative: true,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "Spanish (Mexican)",
            languageCode: "es-MX",
            aac_id: "Andrés-(AI)",
            id: "Andrés",
            gender: "Male",
            generative: true,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "Spanish (Mexican)",
            languageCode: "es-MX",
            aac_id: "Mia-(AI)",
            id: "Mia",
            gender: "Female",
            generative: true,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "Spanish (Spain)",
            languageCode: "es-ES",
            aac_id: "Lucia-(AI)",
            id: "Lucia",
            gender: "Female",
            generative: true,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "Spanish (Spain)",
            languageCode: "es-ES",
            aac_id: "Sergio-(AI)",
            id: "Sergio",
            gender: "Male",
            generative: true,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "Spanish (US)",
            languageCode: "es-US",
            aac_id: "Lupe-(AI)",
            id: "Lupe",
            gender: "Female",
            generative: true,
            longFormVoice: false,
            isNeural: true,
            isStandard: true
        },
        {
            languageName: "Spanish (US)",
            languageCode: "es-US",
            aac_id: "Pedro-(AI)",
            id: "Pedro",
            gender: "Male",
            generative: true,
            longFormVoice: false,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "English (US)",
            languageCode: "en-US",
            aac_id: "Danielle",
            id: "Danielle",
            gender: "Female",
            generative: false,
            longFormVoice: true,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "English (US)",
            languageCode: "en-US",
            aac_id: "Gregory",
            id: "Gregory",
            gender: "Male",
            generative: false,
            longFormVoice: true,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "English (US)",
            languageCode: "en-US",
            aac_id: "Ruth",
            id: "Ruth",
            gender: "Female",
            generative: false,
            longFormVoice: true,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "English (US)",
            languageCode: "en-US",
            aac_id: "Danielle-(AI)",
            id: "Danielle",
            gender: "Female",
            generative: true,
            longFormVoice: true,
            isNeural: true,
            isStandard: false
        },
        {
            languageName: "English (US)",
            languageCode: "en-US",
            aac_id: "Ruth-(AI)",
            id: "Ruth",
            gender: "Female",
            generative: true,
            longFormVoice: true,
            isNeural: true,
            isStandard: false
        }
    ];
    constructor(
        public genHttp: GeneralService,
    )
    {

    }
    public pollySynthesis(voice: any, text2Synthesis: string): Promise<any> {
        //  curl -i -H "Authorization: Basic c2t5Ym94TGljZW5zZTpza3liMHhQNCQk" -H "Content-Type:application/json" -X \
        //  POST -d "{\"voiceId\":\"Salli\",\"text\":\"This is a test text to speech.\"}" http://localhost:8080/skyboxaaclicense/createTTSFile/

        const postData = {
            voiceId: voice.id,
            text: text2Synthesis,
            isSSML: 'N',
            engine: voice.engine
        };
        if (voice.useConversational)
        {
            postData.isSSML = 'Y';
            postData.text = postData.text.replace(/"/g, '&quot;');
            postData.text = postData.text.replace(/&/g, '&amp;');
            postData.text = postData.text.replace(/'/g, '&apos;');
            postData.text = postData.text.replace(/>/g, '&gt;');
            postData.text = postData.text.replace(/</g, '&lt;');
            postData.text = postData.text = '<speak><amazon:domain name="conversational">' + postData.text + '</amazon:domain></speak>';

        }
        return new Promise((resolve, reject) => {
            const URL = 'awsURL/createTTSFile';
            this.genHttp.icPost(URL, JSON.stringify(postData))
                .pipe(map((response: any) => response))
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    getLanguages(): any[]{
        return this.languages;
    }
    getVoices(): Observable<any[]> {
        if (this.cachedVoices) {
            return of(this.cachedVoices);
        }
        return this.genHttp.icGet('awsURL/getTTSVoices').pipe(
            map((response) => {
                this.cachedVoices = response.voices;
                return this.cachedVoices;
            })
        );
    }

}
